<template>
    <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate"  label-width="120px">
        <FormGroup>目标</FormGroup>
        <el-form-item label="媒体" prop="plat_id">
            <el-radio-group v-model="formData.plat_id" :disabled="isView" @change="changePlat">
                <el-radio-button v-for="item in platList" :label="item.id" :key="item.id" v-if="availablePlat.includes(item.id)">{{item.name}}</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="目标维度" prop="dimension">
            <div slot="label" class="inline-block">
                目标维度
                <el-tooltip  effect="dark" content="按照选择的维度汇总数据，添加的条件按照该维度汇总的数据进行判断" placement="top-start">
                    <i class="el-icon-question pointer"/>
                </el-tooltip>
            </div>
            <el-radio-group v-model="formData.dimension" @change="changeDimension" :disabled="isView">
                <el-radio-button label="1">账户</el-radio-button>
                <el-radio-button label="2">产品</el-radio-button>
                <el-radio-button label="3">{{isHuaweiPlat?'计划(任务)':'计划'}}</el-radio-button>
                <el-radio-button label="4">{{isHuaweiPlat?'创意(子任务)':'创意'}}</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="维度筛选" prop="dimension_config" class="label-required">
            <el-radio-group v-model="formData.dimension_config" :disabled="dimensionConfigLoading||isView" @change="changeDimensionConfigType">
                <el-radio-button v-for="item in dimensionConfig" :key="item.id" :label="item.id" :disabled="item.disabled" v-if="checkIsShowDimension(item)">
                    <span>{{item.display_dimension_config}}</span>
                    <MiniToolTips v-if="item.tip" :content="item.tip"></MiniToolTips>
                </el-radio-button>
            </el-radio-group>

            <p class="text-color-error font12px mt6" v-if="tipText">
                <span class="icon iconfont icon-jt-tishi" style="font-size: 14px;"></span>
                {{tipText}}
            </p>
        </el-form-item>
        <el-form-item label="" prop="dimension_data" class="label-required">
            <div class="" v-if="!isAttributeAll">
                <div class="">
                    <el-button type="primary" @click="showBatchModal" :disabled="isView" plain>批量选择</el-button>
                </div>

                <div class="clearfix mt10">
                    <div class="search-wrap fl" v-if="!isView">
                        <div>
                            <el-input v-model="searchInput" ref="searchInput" prefix-icon="el-icon-search" :disabled="isView" @keyup.enter.native="getSearchData" clearable :placeholder="searchPlaceHolder"></el-input>
                            <div class="search-list" v-loading="searchDataLoading">
                                <ul>
                                    <li v-if="searchDataList.length>0">
                                        <p class="mt10 font12px">
                                            <span class="pointer text-color-primary ml24" @click="searchCheckAll(true)">全选</span>
                                            <span class="pointer text-color-primary ml24" @click="searchCheckAll(false)">取消全选</span>
                                        </p>
                                    </li>
                                    <li class="clearfix list-item" v-for="item in searchDataList" v-loading="searchDataLoading" :key="item.id">
                                        <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                            <span v-if="curDimensionConfigText.includes('集团')||curDimensionConfigText.includes('客户')">{{item.name}}(账户数量：{{item.allow_count}})</span>
                                            <span v-else-if="curDimensionConfigText.includes('产品')">{{item.name}}({{item.idd||item.id}})({{item.subproject_content}})(账户数量：{{item.allow_count}})</span>
                                            <span v-else>{{item.name}}({{item.idd||item.id}})</span>
                                        </el-checkbox>

                                        <div class="fr inline-block">
                                            <span v-if="item.is_allow_all_account=='2'" class="text-color-error mr10 font12px">非全部账户权限</span>
                                            <span v-if="showAccountModal&&+item.account_num>0" class="text-color-primary pointer" @click="showAccountDetailModal(item)">详情</span>
                                        </div>
                                    </li>
                                    <li class="mt4 mb4" v-if="!searchDataLoading&&searchDataList.length<=0">
                                        <p class="tac text-color-gray mt10 font12px">暂无数据</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="page-bar tac mt20">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="searchPn"
                                    :page-sizes="[10, 30,50]"
                                    :pager-count="5"
                                    layout="total, sizes, prev, pager, next"
                                    :total="totalCnt">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="result-wrap fl">
                        <h3 class="font12px relative">已选（{{formData.dimension_config_data.length}}）
                            <span v-if="!isView&&formData.dimension_config_data.length>0" class="text-color-error pointer absolute " style="right:10px;" @click="clearResultList">清空</span>
                        </h3>
                        <div class="result-list">
                            <ul class="mb30 pr16">
                                <li class="mt4 mb4" v-if="formData.dimension_config_data.length<=0">
                                    <p class="tac text-color-gray mt10 font12px">暂无数据</p>
                                </li>
                                <li v-for="item in formData.dimension_config_data" :key="item.id" class="relative mt4 mb4 font12px list-item clearfix">
                                    <span v-if="curDimensionConfigText.includes('集团')||curDimensionConfigText.includes('客户')">{{item.name}}(账户数量：{{item.allow_count}})</span>
                                    <span v-else-if="curDimensionConfigText.includes('产品')">{{item.name}}({{item.idd||item.id}})({{item.subproject_content}})(账户数量：{{item.allow_count}})</span>
                                    <span v-else>{{item.name}}({{item.idd||item.id}})</span>
                                    <div class="fr inline-block">
                                        <span v-if="item.is_allow_all_account=='2'" class="text-color-error mr10">非全部账户权限</span>
                                        <span v-if="showAccountModal&&+item.account_num>0" class="text-color-primary pointer" @click="showAccountDetailModal(item)">详情</span>
                                        <span class="clear-btn pointer text-color-error p4" v-if="!isView" @click="removeResultItem(item)"
                                              title="删除">x</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </el-form-item>


        <el-form-item label="二级筛选" prop="dimension_type">
            <div class="dimension-type-list mt10 relative">
                <div v-for="(item,index) in formData.dimension_type" :key="'dimension-type'+index" class="mb10">
                    <el-cascader
                        placement="bottom-start"
                        popper-class="cascader-list-height-300"
                        size="mini"
                        class="mr20"
                        v-model="item.name"
                        :options="textConditionOptions"
                        @change="(val)=>changeTextConditionOptions(item,val)"
                        :props="{value:'name',label:'display_name',emitPath:false,expandTrigger: 'hover',}"
                        :show-all-levels="false"
                        :filterable="true"
                        :disabled="isView"
                        v-label="{title:'类型筛选：',color:'#016FA0'}">
                        <template slot-scope="{ node, data }">
                            <template v-if="(data.config||{}).title">
                                <span>{{data.display_name}}</span>
                                <el-tooltip class="item" effect="dark" :content="data.config.title" placement="top">
                                    <i class="el-icon-question pointer ml4 text-color-normal" ></i>
                                </el-tooltip>
                            </template>
                            <span v-else>{{ data.display_name }}</span>
                        </template>
                    </el-cascader>
                    <el-select
                        size="mini"
                        class="mr20"
                        v-model="item.include"
                        v-label="{title:'包含：',color:'#A36717'}"
                        :disabled="isView||item.editable===false||true"
                        placeholder="请选择">
                        <!--<el-option v-for="(value,label) in item.operator" :label="value" :value="label"></el-option>-->
                        <el-option label="包含" value="1"></el-option>
                        <el-option label="不包含" value="2"></el-option>
                    </el-select>
                    <el-select
                        multiple
                        size="mini"
                        class="mr20"
                        v-model="item.type"
                        v-label="{title:'选项：',color:'#A36717'}"
                        :disabled="isView"
                        style="width: 250px;"
                        placeholder="请选择">
                        <el-option v-for="(value,label) in item.textOptionList" :label="value" :value="label" :key="''+value+label"></el-option>
                    </el-select>
                    <span class="text-color-error el-icon-delete-solid pointer" v-if="!isView" @click="removeDimensionType(index)" title="删除"></span>

                </div>
                <div class="add-dimension-type-btn tac pointer" @click="addDimensionType" v-if="!isView&&!isHideDimensionTypeAddBtn">
                    <span class="text-color-primary font12px">+ 添加筛选</span>
                </div>
            </div>


        </el-form-item>
    </el-form>
</template>

<script>
    import FormGroup from '../formGroup';
    import MiniToolTips from '../create/miniToolTips';
    import {batchChooseModal,accountDetailModal} from '../../modal/index';
    import API from '@/api/intelligent/intelligentManaged/index.js';
    import {uniq,cloneDeep } from 'lodash';


    export default {
        name: "GoalInfo",
        components:{
            FormGroup,
            MiniToolTips,
        },
        inject: ['validFormItem','isView','dimensionOptionList','condition_config','isEdit','conditionFormData'],
        props:{
            platList:Array,
            pageFunc:Array,
        },
        data(){
            let _this = this;
            const dimensionData = (rule, value, callback) =>{
                if(_this.isAttributeAll){
                    callback();
                }else{
                    if(_this.formData.dimension_config_data.length<=0){
                        callback(new Error('维度筛选数据不能为空'));
                    }else if(_this.formData.dimension_config_data.length>1000){
                        callback(new Error('维度筛选数据最多支持1000条'));
                    }else{
                        callback();
                    }
                }
            };
            const dimensionType = (rule, value, callback) => {
                let data = _this.formData.dimension_type;
                if (data.every(item=>item.name&&item.include&&item.type.length>0)) {
                    callback();
                } else {
                    callback(new Error('类型筛选填写不完整，请检查'));
                }
            };
            return {
                availablePlat:['1','7'],       // 用来标识目前支持的媒体
                formData:{
                    plat_id:'',
                    dimension:'2',
                    dimension_config:'',    //维度筛选名称指定产品
                    dimension_config_data:[],        // 维度筛选内容ID json字符串
                    dimension_type:[],
                },
                rules:{
                    plat_id:[
                        {required:true,message:'请选择渠道',trigger:'blur'},
                    ],
                    dimension:[
                        {required:true,message:'请选择目标维度',trigger:'blur'},
                    ],
                    dimension_data:[
                        { required:true, validator: dimensionData, trigger: 'submit' },
                    ],
                    dimension_type:[
                        { required:false, validator: dimensionType, trigger: 'submit' },
                    ],
                },
                dimensionList:[
                    { value:'account',name:'账户'},
                    { value:'app',name:'产品'},
                    { value:'plan',name:'计划'},
                    { value:'idea',name:'创意'},
                ],

                searchInput:'',     // 维度搜索列表的input
                searchDataList:[],
                searchDataLoading:false,
                totalCnt:0,
                searchPn:1,
                searchRn:10,

                oldTempData:{
                    plat_id:'',
                    dimension:'',
                    dimension_config:'',
                },
                dimensionConfig:[],     // attribute: 0-所有，1-指定，2-其他
                dimensionConfigLoading:false,
                batchChooseModal:null,
                baseDimensionTypeData:{
                    editable:true,
                    id:'',
                    name:'',
                    include:'1',        //  仅可选包含
                    type:[],
                    textOptionLoading:false,
                    textOptionList:[],
                },
            }
        },
        computed:{
            isHuaweiPlat(){
                return this.formData.plat_id == '4';
            },
            tipText(){
                let configItem = this.dimensionConfig.find(item=>item.id==this.formData.dimension_config)||{};
                return configItem.tip;
            },
            hasDimensionData(){
                /* 动态计算有没有添加维度筛选 */
                return this.formData.dimension_config_data.length>0;
            },
            hasDimensionType(){
                return this.formData.dimension_type.length>0&&this.formData.dimension_type.some(item=>!!item.id);
            },
            hasCondition(){
                /*判断有没有添加条件，仅用了field字段来判断*/
                let jsonStr = JSON.stringify(this.conditionData);
                let regex = /"field"\s*:\s*"([^"]*)"/g;
                let matches = [...jsonStr.matchAll(regex)];
                return matches.map(item=>item[1]).filter(item=>!!item).length>0;
            },
            pageFuncNames(){
                return this.pageFunc.map(item=>item.name);
            },
            isAttributeAll(){
                let configItem = this.dimensionConfig.find(item=>item.id==this.formData.dimension_config)||{};
                return configItem.attribute=='0';
            },
            curDimensionConfigId(){
                //维度筛选类型 1集团 2客户 3账户 4产品 5计划 6创意
                let configItem = this.dimensionConfig.find(item=>item.id==this.formData.dimension_config)||{};
                return configItem.dimension_config_id;
            },
            dimensionOptions(){
                return this.dimensionOptionList();
            },
            textConditionOptions(){
                return this._filterConditionsOptions2(this.dimensionOptions,['text']);
            },
            conditionConfig(){
                return this.condition_config();
            },
            curDimensionConfigText(){
                let curDimensionConfig = this.dimensionConfig.find(item=>item.id==this.formData.dimension_config)||{};
                return curDimensionConfig.display_dimension_config||'';
            },
            searchPlaceHolder(){
                let tipText = '输入名称关键字后回车搜索';
                let displayText = this.curDimensionConfigText;
                if(displayText.includes('产品')){
                    tipText = '输入名称/ID/包名关键字后回车搜索';
                }else if(displayText.includes('账户')||displayText.includes('计划')){
                    tipText = '输入名称/ID关键字后回车搜索';
                }
                return tipText;
            },
            showAccountModal(){
                /* 只有指定产品、客户、集团时才显示【详情】按钮和弹窗 */
                return this.curDimensionConfigText.includes('产品')||this.curDimensionConfigText.includes('客户')||this.curDimensionConfigText.includes('集团');
            },
            allDimensionTypeFields(){
                let list = [];
                // (this.textConditionOptions||[]).forEach(item=>{
                //     let children = item.children||[];
                //     if(children.length>0){
                //         children.forEach(child=>{
                //             let innerChild = child.children||[];
                //             if(innerChild.length>0){
                //                 innerChild.forEach(field=>{
                //                     list.push({...field});
                //                 })
                //             }
                //         })
                //     }
                // });
                (this.textConditionOptions||[]).forEach(item=>{
                    let children = item.children||[];
                    if(children.length>0){
                        children.forEach(child=>{
                            list.push({...child});
                        })
                    }
                });

                return list;
            },
            isHideDimensionTypeAddBtn(){
                let allListId = (this.allDimensionTypeFields||[]).map(item=>item.id);
                let formIds = this.formData.dimension_type.map(item=>item.id).filter(item=>!!item);
                return (allListId.length===formIds.length)&&(allListId.every(item=>formIds.includes(item)));
            },
            conditionData(){
                let formData = this.conditionFormData()||{};
                return cloneDeep(formData.conditions)||{};
            },
            isHasKpiCondition(){
                return JSON.stringify(this.conditionData).includes(`"condition_type":"kpi_data"`);
            },
        },
        mounted(){
            let firstPlat = this.platList.filter(item=>this.availablePlat.includes(item.id))[0]||{};
            this.formData.plat_id = firstPlat.id||'7';
            this.formData.dimension = '2';      // 产品

            this.oldTempData.plat_id = this.formData.plat_id;
            this.oldTempData.dimension = this.formData.dimension;
            this.$emit('updatePlat',this.formData.plat_id);
            this.getDimensionConfig();

            // this.setFirstDimensionType();
        },
        methods:{
            async setFormData(data){
                console.log('setFormData - goal',data);

                this.formData.plat_id = data.plat_id;
                this.formData.dimension = data.dimension;
                this.$bus.$emit('dimensionChange', data.dimension, false)
                await this.getDimensionConfig().then(()=>{
                    this.formData.dimension_config = data.dimension_config_id;
                    this.oldTempData.dimension_config = data.dimension_config_id;

                    this.formData.dimension_config_data = ((data.dimension_config_data||{}).list||[]).map(item=>{
                        if(this.curDimensionConfigId=='1'||this.curDimensionConfigId=='2'){
                            item.idd = item.id;
                            item.id = item.name;
                        }
                        return item;
                    });
                });

                let dimensionType = JSON.parse(data.dimension_type||"[]");
                this.formData.dimension_type = [...dimensionType];

                this.oldTempData.plat_id = data.plat_id;
                this.oldTempData.dimension = data.dimension;

            },
            async setFirstDimensionType(){
                if(this.formData.plat_id!='7') return;
                if(this.formData.id) return;        // 编辑和复制不用重置值
                // 仅针对小米渠道，默认筛选类型：客户账户信息/数据来源为3.0
                let actionData = this._findFieldByName(this.textConditionOptions,'source_version')||{};
                const { data:optionData } =  await API.getComparativeValueConfig({
                    plat_id:'7',
                    field:actionData.name,
                });
                let keyEntries = Object.entries(optionData).find(([key, value]) => value === '3.0');
                let firstType = keyEntries ? keyEntries[0] : '';
                this.formData.dimension_type = [
                    {
                        editable:true,
                        name:actionData.name,
                        id:actionData.id,
                        include:'1',
                        type:firstType?[firstType]:[],
                        textOptionLoading:false,
                        textOptionList:optionData||[],
                    }
                ];
                
            },
            handleValidate(key, valid, info){
                const data = {
                    plat_id: '目标-媒体',
                    dimension: '目标-目标维度',
                    dimension_data: '目标-维度筛选',
                    dimension_type: '目标-类型筛选',
                };
                if (!valid) {
                    this.validFormItem(`${data[key]}：${info}`);
                }
            },
            changePlat(val){
                console.log('changePlat',val);

                if(this.oldTempData.plat_id){
                    if(this.hasDimensionData||this.hasDimensionType||this.hasCondition){
                        let tip = '修改媒体后当前编辑的内容不会被保存，确定要修改吗？';
                        this.$confirm(tip, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.oldTempData.plat_id = val;
                            console.log('change plat confirm',val);
                            console.log('reset data',val);
                            this.$emit('updatePlat',this.formData.plat_id);
                            this.formData.dimension_type = [];
                            this.formData.dimension_config_data = [];
                            this.searchDataList = [];
                            this.searchInput = '';
                            this.getDimensionConfig();
                            this.setFirstDimensionType();

                        }).catch(() => {
                            this.formData.plat_id = this.oldTempData.plat_id;
                        });
                    }else{
                        /* 切换渠道后 目标维度默认为产品 */
                        this.formData.dimension = '2';
                        this.$emit('updatePlat',this.formData.plat_id);
                        this.formData.dimension_type = [];
                        this.formData.dimension_config_data = [];
                        this.searchDataList = [];
                        this.searchInput = '';
                        this.getDimensionConfig();
                        this.setFirstDimensionType();
                    }
                }else{
                    /* 切换渠道后 目标维度默认为产品 */
                    this.formData.dimension = '2';
                    this.$emit('updatePlat',this.formData.plat_id);
                    this.formData.dimension_type = [];
                    this.formData.dimension_config_data = [];
                    this.searchDataList = [];
                    this.searchInput = '';
                    this.getDimensionConfig();
                    this.setFirstDimensionType();
                }
            },
            changeDimension(val){
                if(this.hasDimensionData){
                    let tip = '修改目标维度后已经添加的维度筛选不会被保存，确定要修改吗？';
                    this.$confirm(tip, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if(this.isHasKpiCondition&&val=='1'){
                            // val==1,表示为账户
                            let tip = '仅目标维度为产品、计划、创意时可对比产品KPI数据，修改为账户后，将清除KPI数据的对比项，确定要修改吗？';
                            this.$confirm(tip, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.oldTempData.dimension = val;
                                this.formData.dimension_config_data = [];
                                this.searchDataList = [];
                                this.searchInput = '';
                                this.getDimensionConfig();
                                this.$refs.ruleForm.clearValidate('dimension_data');

                                this.$store.commit('intelligent/CLEAR_CONDITIONS_KPI');
                                this.$bus.$emit('dimensionChange', val)
                            }).catch(() => {
                                this.formData.dimension = this.oldTempData.dimension;
                            });
                        }else{
                            this.oldTempData.dimension = val;
                            this.formData.dimension_config_data = [];
                            this.searchDataList = [];
                            this.searchInput = '';
                            this.getDimensionConfig();
                            this.$refs.ruleForm.clearValidate('dimension_data');
                             this.$bus.$emit('dimensionChange', val)
                        }
                    }).catch(() => {
                        this.formData.dimension = this.oldTempData.dimension;
                    });
                }else{
                    if(this.isHasKpiCondition&&val=='1'){
                        // val==1,表示为账户
                        let tip = '仅目标维度为产品、计划、创意时可对比产品KPI数据，修改为账户后，将清除KPI数据的对比项，确定要修改吗？';
                        this.$confirm(tip, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.oldTempData.dimension = val;
                            this.formData.dimension_config_data = [];
                            this.searchDataList = [];
                            this.searchInput = '';
                            this.getDimensionConfig();
                            this.$refs.ruleForm.clearValidate('dimension_data');

                            this.$store.commit('intelligent/CLEAR_CONDITIONS_KPI');
                             this.$bus.$emit('dimensionChange', val)
                        }).catch(() => {
                            this.formData.dimension = this.oldTempData.dimension;
                        });
                    }else{
                        this.formData.dimension_config_data = [];
                        this.searchDataList = [];
                        this.searchInput = '';
                        this.getDimensionConfig();
                        this.$refs.ruleForm.clearValidate('dimension_data');
                        this.oldTempData.dimension = val;
                        this.$bus.$emit('dimensionChange', val)
                    }
                }
            },
            changeDimensionConfigType(val){

                if(this.hasDimensionData){
                    let tip = '修改维度筛选后已经添加的维度筛选不会被保存，确定要修改吗？';
                    this.$confirm(tip, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.oldTempData.dimension_config = val;
                        this.formData.dimension_config_data = [];
                        this.searchDataList = [];
                        this.searchInput = '';
                        this.$refs.ruleForm.clearValidate('dimension_data');
                    }).catch(() => {
                        this.formData.dimension_config = this.oldTempData.dimension_config;
                    });
                }else{
                    // 直接切换
                    this.oldTempData.dimension_config = this.formData.dimension_config;
                    this.searchInput = '';
                    this.resultList = this.formData.dimension_config_data;
                    this.searchDataList = [];
                    this.$refs.ruleForm.clearValidate('dimension_data');
                }
            },
            getDimensionConfig(){
                this.dimensionConfigLoading = true;
                return API.getDimensionConfig({
                    plat_id:this.formData.plat_id,
                    search_type:this.formData.dimension,
                }).then(res=>{
                    console.log('getDimensionConfig',res);
                    this.dimensionConfig = (res.data||[]).filter(item=>{
                        if(this.isView||this.isEdit) return true;
                        return item.disabled===false;
                    });
                    this.dimensionConfigLoading = false;

                    let actionItem = this.dimensionConfig.find(item=>item.attribute=='1')||{};  // 1-指定
                    if(actionItem){
                        this.formData.dimension_config = actionItem.id||'';
                        this.oldTempData.dimension_config = this.formData.dimension_config;
                    }
                },err=>{
                    console.log('getDimensionConfig err',err);
                    this.dimensionConfig = [];
                    this.dimensionConfigLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                });
            },
            showBatchModal(){
                this.batchChooseModal = batchChooseModal({
                    props:{
                        typeText:this.curDimensionConfigText,
                    },
                    cbs:{
                        onSubmit:(data,cb)=>{
                            console.log('onSubmit：批量',data,this.batchChooseModal);

                            if(uniq(data).length>1000) {
                                this.$message.error('最多可批量导入1000条数据');
                                return cb();
                            }
                            API.getDimensionSearchList({
                                plat_id:this.formData.plat_id,
                                search_type:this.formData.dimension_config,
                                search:'',
                                batch_search:data,
                            }).then(res=>{
                                let resData = res.data||[];
                                let errList = resData.err_list||[];
                                let successList = (resData.list||[]).map(item=>{
                                    if(this.curDimensionConfigId=='1'||this.curDimensionConfigId=='2'){
                                        item.idd = item.id;
                                        item.id = item.name;
                                    }
                                    return item;
                                });
                                if(errList.length>0){
                                    let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                                    htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                                    htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                                    this.$confirm(htmlStr, '提示', {
                                        confirmButtonText: '剔除',
                                        cancelButtonText: '关闭',
                                        dangerouslyUseHTMLString: true,
                                        type: 'error',
                                        customClass:'batch-err-tips-modal',
                                        width:'500',
                                    }).then(()=>{
                                        successList.forEach(item=>{
                                            this.itemCheckChange(item,true);
                                        });
                                        this.batchChooseModal.vm.close();
                                    }).catch(()=>{
                                        cb();
                                    });
                                }else{
                                    successList.forEach(item=>{
                                        this.itemCheckChange(item,true);
                                    });
                                    this.batchChooseModal.vm.close();
                                }
                            },err=>{
                                console.log('getDimensionSearchList err',err);
                                this.searchDataList = [];
                                this.searchDataLoading = false;
                                this.totalCnt = 0;
                                if (err.code == '403') {
                                    this.$confirm(err.info||'请求异常', '提示', {
                                        confirmButtonText: '刷新',
                                        type: 'warning',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {
                                    });
                                    return
                                }
                                this.$message.error(err.info||'请求异常');
                            });
                        },
                    },
                })
            },

            checkIsShowDimension(item){
                if(item.attribute!='0') return true;
                if(this.isView||this.isEdit) return true;
                if(this.formData.dimension=='1'&&!this.pageFuncNames.includes('all_company')){
                    return false;
                }
                if(this.formData.dimension=='2'&&!this.pageFuncNames.includes('all_app')){
                    return false;
                }
                if(this.formData.dimension=='3'&&!this.pageFuncNames.includes('all_plan')){
                    return false;
                }
                if(this.formData.dimension=='4'&&!this.pageFuncNames.includes('all_ad')){
                    return false;
                }
                return true;
            },
            getSearchData(){
                this.searchDataLoading = true;
                API.getDimensionSearchList({
                    plat_id:this.formData.plat_id,
                    search_type:this.formData.dimension_config,
                    search:this.searchInput,
                    batch_search:'',
                    rn:this.searchRn,
                    pn:this.searchPn,
                }).then(res=>{
                    console.log('getDimensionSearchList',res);


                    let resData = res.data||{};
                    if(resData.reason){
                        return this.$message.error(resData.reason);
                    }

                    let listData = (resData.list||[]).map(item=>{
                        if(this.curDimensionConfigId=='1'||this.curDimensionConfigId=='2'){
                            item.idd = item.id;
                            item.id = item.name;
                        }
                        return item;
                    });

                    let resultListIds = this.formData.dimension_config_data.map(item=>item.id);
                    this.searchDataList =  listData.map(item=>{
                        item.checked = resultListIds.includes(item.id);
                        return item;
                    });
                    this.searchDataLoading = false;
                    this.totalCnt = resData.totalCnt||0;
                },err=>{
                    console.log('getDimensionSearchList err',err);
                    this.searchDataList = [];
                    this.searchDataLoading = false;
                    this.totalCnt = 0;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                });
            },
            searchCheckAll(val){
                this.searchDataList.forEach(item=>{
                    item.checked = val;
                    this.itemCheckChange(item,val);
                });

            },
            itemCheckChange(data,val){
                let  resultIndex = this.formData.dimension_config_data.findIndex(item=>item.id==data.id);
                if(val){
                    if(resultIndex==-1){
                        this.formData.dimension_config_data.unshift({...data});
                    }
                }else{
                    if(resultIndex!=-1){
                        this.formData.dimension_config_data.splice(resultIndex,1);
                    }
                }


                this.$refs.ruleForm.validateField('dimension_data');
            },
            handleSizeChange(val){
                this.searchRn= val;
                this.getSearchData();
            },
            handleCurrentChange(val) {
                this.searchPn= val;
                this.getSearchData();
            },
            clearResultList(){
                this.formData.dimension_config_data = [];
                this.searchDataList.forEach(item => {
                    item.checked = false;
                });

                this.$refs.ruleForm.clearValidate('dimension_data');
            },
            removeResultItem(item){
                console.log('removeResultItem',item);
                if(this.isView) return;
                let resultIndex = this.formData.dimension_config_data.findIndex(inner => inner.id == item.id);
                let searchIndex = this.searchDataList.findIndex(inner => inner.id == item.id);
                if (resultIndex != '-1') {
                    this.formData.dimension_config_data.splice(resultIndex, 1);
                }
                if (searchIndex != '-1') {
                    this.searchDataList[searchIndex].checked = false;
                }
            },
            showAccountDetailModal(item){
                console.log('showAccountDetailModal',item);
                let curDimensionConfigText = (this.curDimensionConfigText||'').replace('指定','');
                accountDetailModal({
                    props:{
                        title:'账户详情 （'+curDimensionConfigText+'：'+item.name+'）',
                        customClass:'modal-body-padding-top-20',
                        data:{...item},
                    },
                    cbs:{
                    },
                })
            },
            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();

                if (valid) {
                    return {...this.formData}
                }

            },
            addDimensionType(){
                this.formData.dimension_type.push({...this.baseDimensionTypeData});
            },
            removeDimensionType(index){
                this.formData.dimension_type.splice(index,1);
            },
            changeTextConditionOptions(item,val){
                console.log('changeTextConditionOptions',item,val);

                if(this.formData.dimension_type.filter(item=>item.name==val).length>1){
                    this.$nextTick(()=>{
                        item.name= '';
                        item.id = '';
                    });
                    return this.$message.error('该项已添加，请勿重复添加');
                }

                item.textOptionLoading = true;
                item.textOptionList = [];
                item.type = [];

                let actionData = this._findFieldByName(this.textConditionOptions,val);
                item.id = actionData.id||'';

                // let activeField = this._findFieldByName(this.conditionOptions,val);
                // let config = typeof activeField.config==='string'?JSON.parse(activeField.config):activeField.config||{};
                // let conditionSetting = (this.conditionConfig||[]).find(item=>item.condition_type==config.condition_type);
                // this.$set(item,'operator',{...conditionSetting.operator});

                API.getComparativeValueConfig({
                    plat_id:this.formData.plat_id,
                    field:val,
                }).then(res=>{
                    console.log('changeTextConditionOptions',res);
                    item.textOptionLoading = false;
                    item.textOptionList = res.data||[];
                },err=>{
                    console.log('changeTextConditionOptions err',err);
                    item.textOptionLoading = false;
                    item.textOptionList = [];
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _filterConditionsOptions(data,list){
                console.log('_filterConditionsOptions',data,list);
                let newData = [];
                data.forEach(item=>{
                    let children = item.children||[];
                    let allChildren = [];
                    children.forEach(inner=>{
                        allChildren = allChildren.concat(inner.children||[]);
                    });

                    if(allChildren.some(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })){
                        newData.push(item)
                    }
                });
                newData.forEach(data=>{
                    data.children = data.children.filter(inner=>{
                        let innerChildren = inner.children||[];
                        return innerChildren.some(son=>{
                            let config = son.config||{};
                            return list.includes(config.condition_type)
                        })
                    })
                });
                return newData;
            },
            _filterConditionsOptions2(data,list){
                console.log('_filterConditionsOptions2',data,list);
                let newData = [];
                data.forEach(item=>{
                    let children = item.children||[];
                    if(children.some(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })){
                        newData.push(item)
                    }
                });
                newData.forEach(data=>{
                    data.children = data.children.filter(inner=>{
                        let config = inner.config||{};
                        return list.includes(config.condition_type)
                    })
                });
                return newData;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .result-wrap, .search-wrap {
        width: 50%;
        border: solid 1px #ccc;
        padding: 10px;
        height: 300px;
        overflow: hidden;

        .list-item{
            border-bottom: solid 1px #efefef;
        }
    }

    .result-wrap {
        position: relative;
        left: -1px;
    }

    .result-list {
        margin-top: 5px;
        height: 265px;
        overflow-y: auto;
        li{
            white-space: normal;
            line-height: 24px;
            padding: 0 20px 0 10px;
            color: #606266;
            &:hover{
                background-color: #f8f8f9;
            }
        }
        .clear-btn{
            padding: 0 8px;
            /*right: 0;*/
            /*top: 0;*/
        }
    }


    .search-list {
        width: 100%;
        min-height: 200px;
        max-height: 200px;
        overflow-y: auto;
        padding: 6px;
    }

    .dimension-type-list{
        border: solid 1px #ccc;
        width: 880px;
        padding: 20px 20px 10px;

        .add-dimension-type-btn{
            width: 682px;
            border: dashed 1px #ccc;
            line-height: 24px;
            &:hover{
                border: dashed 1px #6fb1d6;
            }
        }
    }
</style>
